// 这里是Vuex的getter模块
const getters = {
    userData: state => state.user.userData,//用户信息
    isLogin: state => state.user.isLogin,
    foreign: state => state.user.foreign,
    topSearch: state => state.app.topSearch,
    payVisible: state => state.app.payVisible,
}
export default getters